var _style, _path, _path2, _g, _g2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMyhealthcare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 100",
    style: {
      enableBackground: "new 0 0 160 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Path_1_1_);}\r\n\t.st1{fill:url(#Path_2_1_);}\r\n\t.st2{fill:#221C1D;}\r\n\t.st3{fill:url(#Path_56_1_);}\r\n\t.st4{fill:url(#Path_57_1_);}\r\n\t.st5{fill:#313131;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    transform: "translate(-96 -92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    transform: "translate(-350.679 -276.544)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_1_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.4903,
    y1: 838.1946,
    x2: 230.7521,
    y2: 838.1946,
    gradientTransform: "matrix(274.4136 0 0 -340.0656 -62797.2148 285460.0312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D80005"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F81D20"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st0",
    d: "M521.6,391.3c-15.3-10.8-30.3-17.5-45.2-16.9c-4.7,0.4-9,1.8-12.5,4.3 c-5.9,4.1-9.8,11.1-11.2,21.4c-2.7,31.4,12.4,43,25.2,51.6c13.4,7.7,29,11.7,46.3,11.8c-15.5-4.2-28-9.6-43.8-20.7 c-10.6-9.1-17.3-18-16.9-35.5C463.9,381.3,478.6,375.2,521.6,391.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.6949,
    y1: 838.1934,
    x2: 229.9568,
    y2: 838.1934,
    gradientTransform: "matrix(274.0562 0 0 -339.703 -62419.4141 285155.6562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D80005"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F81D20"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st1",
    d: "M532.6,391.4c15.3-10.9,30.3-17.6,45.1-17c12.5,0.9,21.5,9.1,23.6,25.5 c2.7,31.4-12.4,43-25.2,51.6c-13.3,7.8-29,11.7-46.2,11.8c15.2-4.2,27.6-9.5,43.2-20.3c0.4-0.3,0.7-0.6,1.1-0.8 c10.3-8.9,16.8-17.9,16.4-35C590.3,381.4,575.6,375.3,532.6,391.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    transform: "translate(652.892 516.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    className: "st2",
    d: "M-141.9-91.1c-0.6,0-1.2-0.1-1.8-0.4c-0.5-0.2-1-0.5-1.4-0.9c-0.4-0.4-0.8-0.9-0.9-1.5 c-0.3-0.6-0.4-1.2-0.4-1.9l0,0c0-0.6,0.1-1.2,0.3-1.8c0.2-0.6,0.5-1.1,0.9-1.5c0.4-0.4,0.9-0.8,1.4-1c0.6-0.3,1.2-0.4,1.8-0.4 c0.7,0,1.3,0.1,1.9,0.4c0.5,0.2,1,0.6,1.3,1c0.4,0.4,0.7,1,0.8,1.5c0.2,0.6,0.3,1.2,0.3,1.8v0.6h-6.7c0,0.7,0.4,1.3,0.9,1.7 c0.5,0.4,1.1,0.6,1.7,0.6c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.5,1.1-0.8l1.2,1c-0.4,0.5-0.9,0.9-1.5,1.2 C-140.3-91.3-141.1-91.1-141.9-91.1z M-139.8-96.4c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.3-0.5-0.5-0.8c-0.2-0.2-0.4-0.4-0.7-0.5 c-0.3-0.1-0.6-0.2-0.9-0.2c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.5-0.7,1.1-0.8,1.7H-139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    className: "st2",
    d: "M-130.8-91.3v-1.1c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1.1,0.4-1.7,0.4c-0.4,0-0.8-0.1-1.2-0.2 c-0.4-0.1-0.7-0.3-1-0.6c-0.3-0.2-0.5-0.5-0.7-0.8c-0.2-0.4-0.3-0.8-0.3-1.2l0,0c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.8-0.9 c0.3-0.3,0.7-0.4,1.1-0.6c0.5-0.1,0.9-0.2,1.4-0.2c0.5,0,1,0,1.4,0.1l1.1,0.3v-0.1c0-0.7-0.2-1.1-0.6-1.4c-0.5-0.3-1-0.5-1.6-0.5 c-0.4,0-0.9,0.1-1.3,0.2c-0.4,0.1-0.8,0.3-1.2,0.4l-0.7-1.7c0.5-0.2,1-0.4,1.5-0.6c0.6-0.1,1.3-0.2,1.9-0.2 c1.3,0,2.4,0.3,2.9,0.9c0.7,0.7,0.9,1.6,0.9,2.7v5.4L-130.8-91.3L-130.8-91.3L-130.8-91.3z M-130.7-95.1 c-0.3-0.1-0.6-0.2-0.9-0.3c-0.4-0.1-0.8-0.1-1.1-0.1c-0.7,0-1.1,0.1-1.5,0.4c-0.4,0.2-0.6,0.6-0.6,1l0,0c0,0.4,0.2,0.7,0.5,0.9 c0.4,0.2,0.8,0.4,1.2,0.4c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.5-0.2,0.8-0.4c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.2,0.2-0.5,0.2-0.8 L-130.7-95.1L-130.7-95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    className: "st2",
    d: "M-126.7-103.8h2.1v12.5h-2.1V-103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    className: "st2",
    d: "M-119.3-91.2c-0.3,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.3-0.4-0.5-0.6-0.9 c-0.1-0.4-0.2-0.8-0.2-1.2v-4.7h-1.1v-1.8h1.1v-2.5h2.1v2.5h2.4v1.8h-2.4v4.3c-0.1,0.5,0.3,1.1,0.9,1.1c0.1,0,0.2,0,0.3,0 c0.4,0,0.8-0.1,1.2-0.3v1.7c-0.3,0.2-0.6,0.3-0.9,0.4C-118.7-91.2-119-91.2-119.3-91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    className: "st2",
    d: "M-115.9-103.8h2.1v4.8c0.3-0.4,0.7-0.8,1.1-1.1c0.5-0.3,1.1-0.5,1.7-0.5c1,0,1.8,0.3,2.4,0.9 c0.6,0.7,0.9,1.4,0.9,2.6v5.8h-2.1v-5.1c0-0.6-0.1-1.1-0.5-1.6c-0.4-0.4-1-0.6-1.5-0.6c-0.5,0-1,0.2-1.4,0.6 c-0.4,0.4-0.6,1-0.6,1.6v5h-2.1L-115.9-103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    className: "st2",
    d: "M-101.7-91.1c-0.7,0-1.3-0.1-1.9-0.4c-0.5-0.3-1-0.6-1.5-0.9c-0.4-0.4-0.7-0.9-0.9-1.5 c-0.2-0.6-0.4-1.2-0.4-1.8l0,0c0-0.6,0.1-1.2,0.4-1.8c0.2-0.6,0.5-1.1,0.9-1.5c0.4-0.4,1-0.8,1.5-1c0.6-0.3,1.2-0.4,1.9-0.4 c0.7,0,1.4,0.1,2.1,0.4c0.6,0.3,1.1,0.7,1.5,1.1l-1.2,1.4c-0.3-0.3-0.7-0.6-1-0.9c-0.4-0.2-0.9-0.3-1.3-0.3c-0.4,0-0.7,0.1-1,0.2 l-0.8,0.6l-0.6,0.9c-0.1,0.4-0.2,0.7-0.2,1.1l0,0c0,0.4,0.1,0.8,0.2,1.1c0.1,0.4,0.3,0.7,0.6,0.9c0.2,0.3,0.5,0.5,0.8,0.7 c0.3,0.2,0.7,0.2,1,0.2c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.5,1-0.9l1.2,1.2c-0.2,0.2-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.4-0.9,0.6 c-0.3,0.2-0.6,0.3-0.9,0.4C-101-91.2-101.4-91.1-101.7-91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    className: "st2",
    d: "M-91.2-91.3v-1.1c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1.1,0.4-1.7,0.4c-0.4,0-0.8-0.1-1.2-0.2 c-0.4-0.1-0.7-0.3-1-0.6c-0.3-0.2-0.5-0.5-0.7-0.8c-0.2-0.4-0.3-0.8-0.3-1.2l0,0c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.8-0.9 c0.3-0.3,0.7-0.4,1.1-0.6c0.5-0.1,0.9-0.2,1.4-0.2c0.5,0,0.9,0,1.4,0.1l1.1,0.3v-0.1c0-0.7-0.2-1.1-0.6-1.4 c-0.5-0.3-1-0.5-1.6-0.5c-0.4,0-0.9,0.1-1.3,0.2c-0.4,0.1-0.8,0.3-1.2,0.4l-0.6-1.6c0.5-0.2,1-0.4,1.5-0.6 c0.6-0.1,1.3-0.2,1.9-0.2c1.3,0,2.4,0.3,2.9,0.9c0.7,0.7,0.9,1.6,0.9,2.7v5.4L-91.2-91.3z M-91.1-95.1c-0.3-0.1-0.6-0.2-0.9-0.3 c-0.4-0.1-0.8-0.1-1.1-0.1c-0.7,0-1.1,0.1-1.5,0.4c-0.4,0.2-0.6,0.6-0.6,1l0,0c0,0.4,0.2,0.7,0.5,0.9c0.4,0.2,0.8,0.4,1.2,0.4 c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.5-0.2,0.8-0.4c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.2,0.2-0.5,0.2-0.8L-91.1-95.1L-91.1-95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    className: "st2",
    d: "M-87.1-100.4h2.1v2c0.2-0.6,0.7-1.2,1.2-1.6c0.5-0.4,1.1-0.6,2-0.6v2.2h-0.1 c-0.4,0-0.8,0.1-1.2,0.2c-0.3,0.2-0.7,0.4-0.9,0.7c-0.3,0.3-0.5,0.7-0.7,1.1c-0.2,0.5-0.2,1-0.2,1.5v3.4H-87L-87.1-100.4 L-87.1-100.4L-87.1-100.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    className: "st2",
    d: "M-76.8-91.1c-0.6,0-1.2-0.1-1.8-0.4c-0.5-0.2-1-0.6-1.4-0.9c-0.4-0.4-0.8-0.9-0.9-1.5 c-0.3-0.6-0.4-1.2-0.4-1.9l0,0c0-0.6,0.1-1.2,0.3-1.8c0.2-0.6,0.5-1.1,0.9-1.5c0.4-0.4,0.9-0.8,1.4-1c0.6-0.3,1.2-0.4,1.8-0.4 c0.7,0,1.3,0.1,1.9,0.4c0.5,0.2,1,0.6,1.3,1c0.4,0.4,0.7,1,0.8,1.5c0.2,0.6,0.3,1.2,0.3,1.8v0.6h-6.7c0,0.7,0.4,1.3,0.9,1.7 c0.5,0.4,1.1,0.6,1.7,0.6c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.5,1.1-0.8l1.2,1c-0.4,0.5-0.9,0.9-1.5,1.2 C-75.2-91.3-76-91.1-76.8-91.1z M-74.7-96.4c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.3-0.5-0.5-0.8c-0.2-0.2-0.4-0.4-0.7-0.5 c-0.3-0.1-0.6-0.2-0.9-0.2c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.5-0.7,1.1-0.8,1.7H-74.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(615.363 516.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    className: "st2",
    d: "M-116.7-96.4v5h-2.1v-12.4h2.1v4.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    transform: "translate(24.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    className: "st2",
    d: "M-134.5-96.4v5h-2.1v-12.4h2.1v4.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    transform: "translate(0.72 19.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    className: "st2",
    d: "M-114.4-118.1h3.3v2.1h-8.2v-2.1h3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(540.947 516.036)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_56_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -307.5612,
    y1: 318.2538,
    x2: -307.2994,
    y2: 318.2538,
    gradientTransform: "matrix(41.2876 0 0 -53.4603 12634.6465 16917.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D80005"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F81D20"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    className: "st3",
    d: "M-61.9-90.7c0,0-0.1,0.9-0.9,0.9c0,0-1.2,0.3-1-1.3c0,0,0.3-1.8,0.6-2.8c0,0,0.9-3.9,1-4 c0,0,0.8-3,1-3.2c0,0,0.6-1.7,1.2-1.9c0,0,0.9-0.3,1.3,0.4c0.1,0.1,0.1,0.2,0.1,0.4c0,0,0.1,4.9,0.3,6c0.1,0.4,0.2,0.8,0.3,1.2 c0,0,0.3-0.2,1.2-2.8c0,0-0.2-3.2,0.9-3.8c0,0,1.3-0.5,1.5,0.9c0,0,0.1,1-0.6,2.6c0,0-0.3,0.6,0.7,4.4c0,0,0.8,3.1,1.1,3.9 c0,0,0.3,1.3-1.3,0.8c0,0-0.9-0.4-1.3-2.3c0,0-0.3-0.9-0.8-3.8c0,0-0.8,2.2-1.6,2.2c0,0-1.1,0.1-1.8-2.3c0,0-0.3-0.7-0.6-3.1 c0,0-0.9,1.8-1.3,6.7C-61.6-91.7-61.9-90.7-61.9-90.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_57_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -306.0066,
    y1: 319.9846,
    x2: -305.7447,
    y2: 319.9846,
    gradientTransform: "matrix(23.1587 0 0 -76.583 7033.9609 24418.2539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D80005"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F81D20"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "st4",
    d: "M-47.6-78.6c0.2,0.4,0,0.9-0.4,1.2c0,0-1,0.8-1.7-0.2c-0.2-0.3-0.3-0.6-0.3-0.9l0.1-2.1 l-0.1-1.5v-1.5c0,0,0.1-1.8,0.1-1.9l0.6-5c0,0-1.4,1.1-2.5-0.4c-0.3-0.6-0.5-1.3-0.6-2c0,0-0.2-1.4-0.1-1.9 c-0.4-0.6-0.4-1.3-0.1-1.9c0,0,0.8-0.8,1.6-0.3c0,0,0.6,0.3,0.4,1.9c0,0-0.1,1.9,0.1,2.6c0,0,0.2,1.2,1,0.4l0.3-0.3 c0,0,0.2-1.8,0.1-2c0,0,0.1-1.4,0.2-1.6c0,0,0.3-1.4,1.4-1.2c0,0,0.9,0.1,0.8,1.2l-0.7,3.1c0,0-0.8,3.2-0.7,3.3 c0,0-0.6,3.2-0.6,4.5c0,0-0.2,2.9,0.1,3.9c0,0,0.2,1.2,0.5,1.6"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-trademark",
    className: "st5",
    d: "M235.8,177.9v0.8c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-2v5.4 c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-0.9c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.2v-5.4h-2c-0.1,0-0.1,0-0.1-0.1 c0,0-0.1-0.1-0.1-0.1v-0.8c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h5.3C235.7,177.7,235.8,177.8,235.8,177.9L235.8,177.9z M242.7,177.9 l0.5,6.4c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1h-0.9c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1l-0.3-3.9l-1.3,2.8 c0,0.1-0.1,0.1-0.2,0.1h-0.8c-0.1,0-0.2,0-0.2-0.1l-1.2-2.8l-0.3,3.9c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-0.9 c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2l0.5-6.4c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h0.9c0.1,0,0.2,0,0.2,0.1l1.5,3.5 c0,0.1,0.1,0.2,0.1,0.3c0,0,0-0.1,0.1-0.2s0.1-0.1,0.1-0.2l1.5-3.5c0-0.1,0.1-0.1,0.2-0.1h0.9C242.6,177.7,242.7,177.8,242.7,177.9 L242.7,177.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMyhealthcare);
export default __webpack_public_path__ + "static/media/logo-myhealthcare.e94c8f2147a8e05970483e610f2a739f.svg";
export { ForwardRef as ReactComponent };